export const getPaperEnvelopeTypeOptions = () => [
  "250 g/qm MultiArt Silk",
  "Unterkarton ServiBoard 300g/qm",
];

export const getPaperContentTypeOptions = () => [
  "135 g/qm MultiArt Silk",
  "80 g/qm SoporSet h'frei weiß",
  "170 g/qm MultiArt Silk",
  "Unterkarton ServiBoard 300g/qm",
];

export const getMediaFormatFoldedOptions = () => [
  "100 x 210 mm",
  "DIN A4",
  "DIN A5",
];

export const getMediaFormatUnFoldedOptions = () => [
  "200 x 210 mm",
  "300 x 210 mm",
  "400 x 210 mm",
  "DIN A4",
  "DIN A5",
];

export const getMediaTypeOptions = () => [
  "Aufkleber",
  "Beileger",
  "Broschüre",
  "CD-ROM/DVD",
  "Flyer",
  "Give Away",
  "Implantatepass",
  "Infografik",
  "Katalog",
  "Mailing",
  "Messe",
  "Packschablonen",
  "Patienteninfo",
  "Poster",
  "Programm",
  "Prospekt",
  "Textbaustein",
];

export const getStatusOptions = () => [
  "Neudruck",
  "Nachdruck verändert",
  "Nachdruck unverändert",
  "Nachdruck mit neuem CD",
  "End of life, Totpunkt",
  "Unterdeckung",
  "nur PDF-Datei",
];

export const getMainCategories = () => [
  {
    title: "Anzeigen / Social Media Ads",
    id: "A",
  },
  {
    title: "Diverses",
    id: "D",
  },
  {
    title: "Veranstaltungen",
    id: "V",
  },
  {
    title: "Video / Animation",
    id: "F",
  },
];

export const getBusinessAreas = () => [
  {
    title: "Sterile Goods Management",
    id: "SGM",
  },
  {
    title: "Neurosurgery",
    id: "NE",
  },
  {
    title: "Orthopaedic Surgery",
    id: "OT",
  },
  {
    title: "Spine Surgery",
    id: "SP",
  },
  {
    title: "Operating Room Supply",
    id: "ORS",
  },
  {
    title: "Dental",
    id: "DE",
  },
  {
    title: "Akademie",
    id: "AK",
  },
  {
    title: "Dienstleistung",
    id: "DL",
  },
  {
    title: "Image",
    id: "IM",
  },
  {
    title: "Personal",
    id: "PE",
  },
  {
    title: "Power Systems",
    id: "PS",
  },
  {
    title: "VetCare",
    id: "VE",
  },
  {
    title: "Sonstiges",
    id: "XX",
  },
  {
    title: "ATS",
    id: "ATS",
  },
  {
    title: "Interventional Vascular Therapy",
    id: "IVT",
  },
  {
    title: "Minimally Invasive Surgery",
    id: "MIS",
  },
  {
    title: "B. Braun Supply Solutions",
    id: "BSS",
  },
  {
    title: "Robotic Surgery",
    id: "ROB",
  },
];



// WEBPACK FOOTER //
// ./src/services/index.js